import * as React from 'react';
import { Button, type ButtonProps } from '@restworld/ui-ds-base';
import Image from 'next/image';
import { customImageLoader } from '@restworld/utils-common';
import { cn } from '@restworld/utils-common';

export interface JobPositionExplorerProps {
  header: string;
  subheader: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonIcon?: ButtonProps['StartIcon'];
  onSubmit?: () => void;
  previewImage: { src: string; blurDataURL?: string; placeholder?: 'blur' };
  buttonFull?: boolean;
}

export const JobPositionExplorer = ({
  header,
  subheader,
  hasButton,
  buttonText,
  buttonIcon,
  onSubmit,
  previewImage,
  buttonFull = false,
}: JobPositionExplorerProps) => {
  return (
    <Container>
      <Body>
        <Left>
          <h2 className="text-white font-semibold lg:text-5xl text-4xl leading-12.75">{header}</h2>
          <h6 className="lg:text-lg text-white lg:leading-6.75 text-base leading-6 mt-4">{subheader}</h6>
          {hasButton && buttonText && onSubmit && (
            <div className="mt-8 w-full">
              <Button StartIcon={buttonIcon} onClick={() => onSubmit()} fullwidth={buttonFull}>
                {buttonText}
              </Button>
            </div>
          )}
        </Left>
        <Right>
          <BackgroundImage {...previewImage} loader={customImageLoader} alt="Restaurant" width={449} height={471} />
        </Right>
      </Body>
    </Container>
  );
};

const Container = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex w-full flex-row justify-center', className)} {...props} />
);

const Body = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'flex lg:flex-row flex-col-reverse lg:w-[57.688rem] lg:max-w-[57.688rem] lg:h-[29.438rem] lg:max-h-[29.438rem] w-full h-fit  rounded-7.5  overflow-hidden',
      className
    )}
    {...props}
  />
);

const Left = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'flex flex-col items-start justify-start lg:w-[29.625rem] w-full lg:py-20.5 lg:pr-8 lg:pl-15.75 bg-primary-900 px-8 pt-8 pb-12',
      className
    )}
    {...props}
  />
);

const Right = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-1 lg:h-full lg:min-h-full h-[300px] min-h-[300px]', className)} {...props} />
);

const BackgroundImage = ({ className, ...props }: any) => (
  <Image className={cn('object-cover lg:w-fit md:!w-full w-full', className)} {...props} />
);
